/**
 * authApi.js (Employee Self-Service)
 * ----------------------------------
 * Handles employee portal authentication and password management.
 * Employees are provisioned in AcHeads by Administrator.
 */
import api from '../../../../api/client';

export const employeeAuthApi = {
  login: async (tenantUsername, username, password) => {
    const response = await api.post('/self-service/auth/login', {
      tenantUsername: tenantUsername?.trim()?.toUpperCase(),
      username: username?.trim(),
      password,
    });
    return response.data;
  },

  changePassword: async (currentPassword, newPassword) => {
    const response = await api.post('/self-service/auth/change-password', {
      currentPassword,
      newPassword,
    });
    return response.data;
  },

  getMe: async () => {
    const response = await api.get('/self-service/auth/me');
    return response.data;
  },
};
